@if (!state()?.isOpen) {
  <div class="top-button-container">
    <button class="open-library-button" (click)="togglePanel()">
      <img [src]="'/svg/chat-library.svg' | assetVersion" alt="Open chat library"/>
      Chat Library
    </button>
  </div>
}

<div class="chat-library-panel" [class.menu-visible]="state()?.isOpen">
  <app-library-header
    [hasContent]="!!state()?.hasContent"
    (closePanel)="onClosePanel()">
  </app-library-header>
  @if (state()?.isLoading) {
    <div class="library-loading-container">
      <div class="skeleton-group-title skeleton-pulse"></div>
      <div class="skeleton-card-grid">
        @for (placeholder of skeletonPlaceholders; track $index) {
          <div class="skeleton-card">
            <div class="skeleton-card-header">
              <div class="skeleton-logo skeleton-pulse"></div>
              <div class="skeleton-line skeleton-pulse"></div>
            </div>
            <div class="skeleton-thumbnail skeleton-pulse"></div>
          </div>
        }
      </div>
    </div>
  } @else {
    <app-library-group-list
      [groups]="state()?.groups ?? []">
    </app-library-group-list>
    @if (state()?.isLoadingMore) {
      <div class="library-loading-container">
        <div class="skeleton-card-grid">
          @for (placeholder of loadMorePlaceholders; track $index) {
            <div class="skeleton-card">
              <div class="skeleton-card-header">
                <div class="skeleton-logo skeleton-pulse"></div>
                <div class="skeleton-line skeleton-pulse"></div>
              </div>
              <div class="skeleton-thumbnail skeleton-pulse"></div>
            </div>
          }
        </div>
      </div>
    }
    @if (hasMore()) {
      <div #sentinel class="sentinel"></div>
    }
  }
</div>
